/* eslint-disable no-undef */
$(function () {
  // //reload
  // var Dwinsize, Nwinsize;

  // if ( window.innerWidth>1024) {
  //   Dwinsize = true;
  // }else{
  //   Dwinsize = false;
  // }

  // $( window ).resize(function(){
  //   if ( window.innerWidth>1024) {
  //     Nwinsize = true;
  //   }else{
  //     Nwinsize = false;
  //   }

  //   if (Dwinsize != Nwinsize) {
  //     $( window ).off('resize');
  //     window.location.reload()
  //   };
  // })

  // main nav fixed
  // Hide Header on on scroll down
  var didScroll
  var lastScrollTop = 0
  var delta = 5
  var navbarHeight = $('header').outerHeight()

  $(window).scroll(function (event) {
    didScroll = true
  })

  setInterval(function () {
    if (didScroll) {
      hasScrolled()
      didScroll = false
    }
  }, 250)

  function hasScrolled () {
    var st = $(this).scrollTop()

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) { return }

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('header.bodyHeader').removeClass('nav-down').addClass('nav-up')
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        $('header.bodyHeader').removeClass('nav-up').addClass('nav-down')
      }
    }

    lastScrollTop = st
  }

  // nav hamburger
  // $( ".mainNav_mobile" ).append( "<a href='#0' class='nav_trigger'>Menu<span></span><span></span><span></span><span></span></a>" );
  // // $( "body" ).prepend( "<div class='bodyWrapper'>" );
  // $( "body" ).append( "</div>" );

  // $('.nav_trigger').click(function(){
  //     $('.nav_trigger').toggleClass('open');
  //     $('.mainNav_mobile').fadeToggle( "slow", "linear" );
  //     $('body, .bodyWrapper').toggleClass('overflowhidden');
  // });

  // search
  // 20191125移除 下面
  // $('.sb-search').click(function(e){
  //     e.stopPropagation();
  //     $(this).addClass('sb-search-open');
  // });
  // $('body').click(function(){
  //     if( $(".sb-search").hasClass("sb-search-open") ){
  //       $(".sb-search").removeClass("sb-search-open");

  //     };
  // });

  // header「會員」功能nav
  // $('.globalMember').hover(function() {
  //     $('.memList').stop().slideDown(300);
  // }, function() {
  //     $('.memList').stop().slideUp(300);
  // });

  // bottomsheet
  // var documentHeight = $(document).height();
  // var windowHeight = $(window).height();
  // var fromBot = documentHeight - 300 - windowHeight;

  // if ($( window ).width() <= 1024) {
  //     $(window).scroll(function(){
  //         var windowScrollTop = $(document).scrollTop();

  //         if(windowScrollTop > 200 && windowScrollTop < fromBot) {
  //           $("#bottomsheet").fadeIn('show');
  //         } else if(windowScrollTop > fromBot) {
  //           $("#bottomsheet").fadeOut('show');
  //         } else if(windowScrollTop < 200) {
  //           $("#bottomsheet").fadeOut('show');
  //         };
  //     });
  // };

  // scrolltoTop
  // $(window).scroll(function () {
  //     var s = $(this).scrollTop();
  //     var m = 300;
  //     if(s > m) {
  //         $("#pagetop").fadeIn('slow');
  //     } else if(s < m) {
  //         $("#pagetop").fadeOut('slow');
  //     };

  // });

  $(window).scroll(function () {
    var s = $(this).scrollTop()
    var m = 300
    if (s > m) {
      $('#pagetop,#bottomsheet,.pagetop').fadeIn('slow')
    } else if (s < m) {
      $('#pagetop,#bottomsheet,.pagetop').fadeOut('slow')
    }
  })

  $('#pagetop p,.pagetop p').click(function () {
    $('html,body').animate({ scrollTop: 0 }, 'slow')
    return false
  })

  // hide QR
  // $('.global_qrcode').css('opacity', '0');

  // 會員登入
  $('.login .wrap').prepend("<button class='closeBtn'><span>Close</span></button>")
  $('.login').append("<a class='overlay'></a>")

  $('.globalMember a.unlogin,.receive_login').click(function () {
    $('.login').fadeIn(200).css('display', 'flex')
    $('body, .bodyWrapper').addClass('overflowhidden')
    return false
  })

  $('.login_udn button').click(function () {
    $('#login_udn').fadeIn(200).css('display', 'flex')
    return false
  })

  $('.login_mobile button').click(function () {
    $('#login_mobile').fadeIn(200).css('display', 'flex')
    return false
  })

  $('.backToMode').click(function () {
    $('.signForm').fadeOut()
    // $('.wrapper').removeClass('noScroll')
  })

  $('.closeBtn , .overlay').click(function () {
    $('.login').fadeOut()
    $('.signForm').fadeOut()
    $('body, .bodyWrapper').removeClass('overflowhidden')
  })

  // 會員header fixed
  // var stickyHeader = $('.sideNav').offset().top;

  // $(window).scroll(function() {
  //     if ($(window).scrollTop() > stickyHeader) {
  //         $('.sideNav').addClass('affix');
  //     }
  //     else {
  //         $('.sideNav').removeClass('affix');
  //     }
  // });
})



// WEBPACK FOOTER //
// ./src/assets/js/function.js